import { useState, useEffect } from "react";

const normalizeRecord = (type, r) => ({
  type,
  agentName: r.agentName,
  amount: r.amount ?? 0,
  created: r.created ?? null,
});

export function useUnclaimedRecords({
  api,
  customerCode,
  refreshToken = 0,
  onError,
}) {
  const [pool, setPool] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (customerCode === undefined) {
      setPool([]);
      setHasLoaded(false);
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    const qs = customerCode
      ? `?customerCode=${encodeURIComponent(customerCode)}`
      : "";
    const fetchAll = async () => {
      setIsLoading(true);
      try {
        const [commRes, bonusRes, chargebackRes] = await Promise.all([
          api.get(`/api/commission/payout-runs/commission-record${qs}`, {
            suppressGlobalError: true,
          }),
          api.get(`/api/commission/payout-runs/bonus-record${qs}`, {
            suppressGlobalError: true,
          }),
          api.get(`/api/commission/payout-runs/chargeback-record${qs}`, {
            suppressGlobalError: true,
          }),
        ]);
        if (cancelled) return;
        const records = [
          ...(commRes.status === 200 ? (commRes.data ?? []) : [])
            .flatMap((r) => r.commissionRecords ?? [])
            .map((r) => normalizeRecord("commission", r)),
          ...(chargebackRes.status === 200 ? (chargebackRes.data ?? []) : []).map((r) =>
            normalizeRecord("chargeback", r),
          ),
          ...(bonusRes.status === 200 ? (bonusRes.data ?? []) : []).map((r) =>
            normalizeRecord("bonus", r),
          ),
        ];
        setPool(records);
      } catch (error) {
        if (!cancelled) onError?.(error);
      } finally {
        if (!cancelled) {
          setIsLoading(false);
          setHasLoaded(true);
        }
      }
    };
    fetchAll();
    return () => {
      cancelled = true;
    };
  }, [customerCode, refreshToken]); // eslint-disable-line react-hooks/exhaustive-deps

  return { pool, isLoading, hasLoaded };
}
